export default __webpack_public_path__ + "media/avatars/01-33c00993.png";